module.exports = __webpack_public_path__ + "static/media/1992-Impreza-GC-WRX.acb92e49.webp";